import React from 'react';
import PropTypes from 'prop-types'; // ES6
import { InputNumber } from 'antd';

import PopoverError from '../commons/popoverError';

const AvisIntroduccioSeccioDadesMeteorCampNumeric = props => {
	const { camp, onModificarValor } = props;
	const { nom, unitat, id, error, valor } = camp;

	const onModificarValorNumeric = valor => {
		if (!isNaN(valor)) {
			onModificarValor(id, valor);
		}
	};

	const errorRenderitzat = error ? <PopoverError contingut='Camp obligatori' /> : null;
	const decimals = id === 44 ? 1 : 0;
	const steps = id === 44 ? 0.1 : 1;
	return (
		<div className='avis-introduccio-seccio-dades-meteor-camp-numeric'>
			<span className='titol'>{nom}:</span>
			<div>
				<InputNumber onChange={onModificarValorNumeric} value={valor} min={0} precision={decimals} step={steps} />
				&nbsp;{unitat}
			</div>
			{errorRenderitzat}
		</div>
	);
};

AvisIntroduccioSeccioDadesMeteorCampNumeric.propTypes = {
	camp: PropTypes.object.isRequired,
	onModificarValor: PropTypes.func
};

export default AvisIntroduccioSeccioDadesMeteorCampNumeric;



// WEBPACK FOOTER //
// ./src/components/avis/avisIntroduccioSeccioDadesMeteorCampNumeric.js